/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Error 520
 * @export
 * @interface GetCorporationsCorporationIdContractsContractIdItemsError520
 */
export interface GetCorporationsCorporationIdContractsContractIdItemsError520 {
    /**
     * Error 520 message
     * @type {string}
     * @memberof GetCorporationsCorporationIdContractsContractIdItemsError520
     */
    error?: string;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdContractsContractIdItemsError520 interface.
 */
export function instanceOfGetCorporationsCorporationIdContractsContractIdItemsError520(value: object): value is GetCorporationsCorporationIdContractsContractIdItemsError520 {
    return true;
}

export function GetCorporationsCorporationIdContractsContractIdItemsError520FromJSON(json: any): GetCorporationsCorporationIdContractsContractIdItemsError520 {
    return GetCorporationsCorporationIdContractsContractIdItemsError520FromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdContractsContractIdItemsError520FromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdContractsContractIdItemsError520 {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetCorporationsCorporationIdContractsContractIdItemsError520ToJSON(json: any): GetCorporationsCorporationIdContractsContractIdItemsError520 {
    return GetCorporationsCorporationIdContractsContractIdItemsError520ToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdContractsContractIdItemsError520ToJSONTyped(value?: GetCorporationsCorporationIdContractsContractIdItemsError520 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

